import APIClient from '@/shared/http/clients/api'

const resourceName = 'movimentacao-auto-card'
const APICore = process.env.APIBaseURLCore

const CreateBoardColumn = (boardColumnId = {}, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/boardcolumn/${boardColumnId}`, data, config)
const CreateBoard = (boardId = {}, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/board/${boardId}`, data, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const MovAutoCardRepository = {
  CreateBoardColumn,
  CreateBoard,
  ChangeStatus,
  Update
}

export default MovAutoCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/movimentacaoAutoCard.js